module.exports = __webpack_public_path__ + "static/img/101400.7e45f3cd.png";